/* istanbul ignore file */
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { DeterministicViewForBackBoneView } from '@bingads-webui/deterministic-wrapper-view';
import { PillControl } from '@bingads-webui/pill-control';
import template from './template.pug';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const { CalloutAdExtensionAssociationsView } = globalContext.require('campaignui/feature/hotel-center-ad-extensions/callout/callout-adextension-associations-view');

class WrappedPillControl extends DeterministicViewForBackBoneView {
  viewFactory(options) {
    return new PillControl(options);
  }
}

class WrappedCalloutAdExtensionAssociationsView extends DeterministicViewForBackBoneView {
  viewFactory(options) {
    return new CalloutAdExtensionAssociationsView(options);
  }
}

export class CalloutExtensionsView extends DeterministicView {
  initialize({ isNewEntitySelector = false, perfMarker } = {}) {
    _.extend(this, {
      isNewEntitySelector,
    });
    super.initialize();
    this.i18n = i18n;
    this.associationsView = new WrappedCalloutAdExtensionAssociationsView({
      associationType: 'SubAccount',
      typeString: i18n.getString('AdExtensionsSummary_Tab_Title_Callout'),
      isNewEntitySelector,
      i18nHotelCenter: i18n,
      perfMarker,
    });

    this.pillControl = new WrappedPillControl({
      items: [
        { text: i18n.getString('HotelCenter_Intelligence_CalloutExtensions_SwitchButton_Subaccount'), id: 'sub-account', value: 0 },
        { text: i18n.getString('HotelCenter_Intelligence_CalloutExtensions_SwitchButton_HotelGroup'), id: 'hotel-group', value: 1 },
      ],
    });

    this.setChild('pill-control', this.pillControl);
    this.setChild('associations-view', this.associationsView);

    this.pillControl.on('select', (event) => {
      const { item } = event;
      if (item.id === 'sub-account') {
        this.associationsView.remove();
        this.associationsView = new WrappedCalloutAdExtensionAssociationsView({
          associationType: 'SubAccount',
          typeString: i18n.getString('AdExtensionsSummary_Tab_Title_Callout'),
          isNewEntitySelector,
          i18nHotelCenter: i18n,
          perfMarker,
        });
        this.setChild('associations-view', this.associationsView);
        this.setState({ associationType: 'sub-account' });
      } else if (item.id === 'hotel-group') {
        this.associationsView.remove();
        this.associationsView = new WrappedCalloutAdExtensionAssociationsView({
          associationType: 'HotelGroup',
          typeString: i18n.getString('AdExtensionsSummary_Tab_Title_Callout'),
          isNewEntitySelector,
          i18nHotelCenter: i18n,
          perfMarker,
        });
        this.setChild('associations-view', this.associationsView);
        this.setState({ associationType: 'hotel-group' });
      }
    });
  }

  get template() {
    return template;
  }
}
